import { useSiteTheme } from 'src/contexts/SiteTheme/SiteThemeContext';
import { vars } from 'src/core/themes';
import { Colors } from 'src/core/themes/constants/colors';

import { PosIconProps, SvgWrapper } from './SvgWrapper';

export function TableSortingIconV2({
  width,
  height,
  isActive,
  ...props
}: PosIconProps & {
  isActive?: boolean;
}) {
  const stroke = vars.color.backgroundBrand;

  return (
    <SvgWrapper
      {...props}
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8 4.99976L11 7.99976M8 4.99976V11M8 4.99976L5 7.99976"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgWrapper>
  );
}
